/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';

import CollapsibleContent from 'components/CollapsibleContent';

const FAQ = ({ faqItem }) => (
  <CollapsibleContent
    className="faqs__list-item"
    title={faqItem.question}
    openByDefault={false}
  >
    <span dangerouslySetInnerHTML={{ __html: faqItem.answer }} />
  </CollapsibleContent>
);

FAQ.propTypes = {
  faqItem: PropTypes.object.isRequired,
};

export default FAQ;



// WEBPACK FOOTER //
// ./src/views/Home/components/FAQs/FAQ.js